import { render, staticRenderFns } from "./MasterDataPublicationDetail.vue?vue&type=template&id=8183813a"
import script from "./MasterDataPublicationDetail.vue?vue&type=script&lang=js"
export * from "./MasterDataPublicationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports